import { put, call, select } from "redux-saga/effects";
import api from "../../services/api";
import history from "../../services/history";
import { toast } from "react-toastify";
import { Creators as UserActions } from "../ducks/user";
import { Creators as AuthActions } from "../ducks/auth";
import { Creators as CartActions } from "../ducks/cart";
import { Creators as ErrorActions } from "../ducks/error";

export function* updateUser({ payload }) {
  try {
    const { uuid } = yield select(state => state.user.profile);
    const { nome, email, celular, genero, dataNascimento, cpf, aceitaOfertas } = payload;

    const { data } = yield call(api.put, `customers/${uuid}`, {
      nome,
      email,
      celular,
      genero,
      dataNascimento,
      cpf,
      aceitaOfertas
    });

    const { message, cliente } = data;

    toast.success(message);
    yield put(UserActions.updateUserSuccess(cliente));
  } catch (err) {
    const message = err.response?.data?.error || 'Erro ao atualizar dados';
    yield put(UserActions.updateUserError(message));
  }
}

export function* getAccount() {
  try {
    // Verifica se há sessão ativa pelo cookie httpOnly
    // /me retorna apenas campos mínimos (uuid, nome, lgpd_aceite, programa_fidelidade)
    // Dados sensíveis só são carregados sob demanda em /account (tela de edição)
    const response = yield call(api.get, "customers/me");
    yield put(UserActions.getAccountSuccess(response.data));
    // Restaura auth.signed = true para que o app reconheça a sessão após F5
    yield put(AuthActions.signInSuccess(response.data));
    // Recarrega o carrinho agora que auth.signed=true e user.profile estão definidos
    // (getStorage no OnInit pode ter rodado antes de /me responder)
    yield put(CartActions.getStorage());
  } catch (err) {
    localStorage.removeItem('@ConexaoGAM:session');
    yield put(UserActions.getAccountFailure());
  }
}

export function* removeUser({ payload }){
  try {
    const { cpf } = payload;
    const { uuid } = yield select(state => state.user.profile);

    yield call(api.put, `customers/${uuid}/deactive`, { cpf })

    yield put(AuthActions.signOut());
    yield put(UserActions.removeLoading());
  } catch (err) {
    yield put(ErrorActions.setError("user-update", err.response.data.error));
  }
}
